import React from "react";
import AccordionTwoColumnGrid from "@/components/molecules/AccordionTwoColumnGrid";
import { useTranslation } from "react-i18next";
import Stack from "@/components/atoms/Stack";
import Text from "@/components/atoms/Text";
import SVGAsset from "@/components/atoms/SVGAsset/SVGAsset";
import { Grid } from "@mantine/core";
import { Controller, Control } from "react-hook-form";
import { RegisterCompanyFormInput } from "@/components/pages/RegisterCompany/validation/registerCompanyValidationSchema";
import SelectTimezone from "@/components/molecules/SelectInputs/SelectTimezone";

interface TimezoneProps {
  control: Control<RegisterCompanyFormInput>;
  saveDraft: () => Promise<void>;
}

const Timezone: React.FC<TimezoneProps> = ({ control, saveDraft }) => {
  const { t } = useTranslation();

  const leftContent = (
    <Stack>
      <Text size="lg" display="technical" tt="uppercase" fw={500} ff="heading">
        {t("registerCompany:timezone.title")}
      </Text>
      <Grid>
        <Grid.Col span={1} pr={0} mr={0}>
          <SVGAsset name="circle-questionmark" />
        </Grid.Col>
        <Grid.Col span={10} pl={0} ml={0}>
          <Text size="sm" color="secondary">
            {t("registerCompany:timezone.reason")}
          </Text>
        </Grid.Col>
      </Grid>
    </Stack>
  );

  const rightContent = (
    <Grid>
      <Grid.Col span={6}>
        <Controller
          name="partialCompany.timeZone"
          control={control}
          render={({ field: { onChange, value, onBlur }, fieldState }) => (
            <SelectTimezone
              id={"timezone"}
              data-testid="timezone-select"
              required
              label={t("registerCompany:timezone.selectTimezone")}
              value={value}
              valueKey="value"
              labelKey="label"
              onChange={onChange}
              onBlur={async () => {
                onBlur();
                await saveDraft();
              }}
              error={fieldState.error?.message ? t(fieldState.error.message) : undefined}
            />
          )}
        />
      </Grid.Col>
    </Grid>
  );

  return <AccordionTwoColumnGrid leftContent={leftContent} rightContent={rightContent} />;
};

export default Timezone;
